import { render } from "./nonacademiccandidate.vue?vue&type=template&id=9a215036"
import script from "./nonacademiccandidate.vue?vue&type=script&lang=js"
export * from "./nonacademiccandidate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__